import React from 'react';

import GeneralErrorContent from '~/components/error/general-error-content';
import Modal from '~/components/modals/modal';

const ErrorModal = ({ onClose, isOpen }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <GeneralErrorContent />
    </Modal>
  );
};

export default ErrorModal;
